export const BENTO_ROW_LAYOUTS = {
  section: {
    gap: '16px',
  },
  detailsPreview: {
    gap: '16px',
    maxColumns: 3,
    justifyContent: 'space-between',
  },
} as const

export const BENTO_COLUMN_LAYOUTS = {
  card: {
    gap: '12px',
  },
  stretch: {
    height: '100%',
  },
} as const

export type BentoRowLayout = keyof typeof BENTO_ROW_LAYOUTS
export type BentoColumnLayout = keyof typeof BENTO_COLUMN_LAYOUTS

type BentoRowLayoutPreset = (typeof BENTO_ROW_LAYOUTS)[BentoRowLayout]

export const BentoLayout = {
  row: (layout?: BentoRowLayout) => (layout ? BENTO_ROW_LAYOUTS[layout] : {}),
  column: (layout?: BentoColumnLayout) =>
    layout ? BENTO_COLUMN_LAYOUTS[layout] : {},
  resolveRow: ({
    layout,
    gap = '16px',
    maxColumns = 4,
  }: {
    layout?: BentoRowLayout
    gap?: string
    maxColumns?: number
  }) => {
    const {
      maxColumns: layoutMaxColumns,
      gap: layoutGap,
      ...gridProps
    } = (layout ? BENTO_ROW_LAYOUTS[layout] : {}) as BentoRowLayoutPreset

    return {
      gap: layoutGap ?? gap,
      maxColumns: layoutMaxColumns ?? maxColumns,
      gridProps,
    }
  },
} as const
